import React from "react";
import { Button, Container, Image } from "react-bootstrap";
import { auth, provider } from "./firebase";

const style = {
  loginContainer: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    borderRadius: "10px",
    border: "2px solid white",
    alignItems: "center",
    padding: "1rem",
    width: "fit-content",
    backgroundColor: "#F7F7F7",
  },
  img: {
    width: "400px",
  },
};

function Login() {
  const signIn = () => {
    auth.signInWithPopup(provider).catch(alert);
  };
  return (
    <Container style={style.loginContainer}>
      <h1 style={{color:"#2d2d2a"}}>messX</h1>
      <Image
        style={style.img}
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBBSI0c8BuDbb-z4d5P4zSTYZvwBZ2GAXwuA&usqp=CAU"
      />
      <Button
        onClick={signIn}
        style={{ width: "fit-content", marginTop: "2rem" }}
      >
        Sign with Google
      </Button>
    </Container>
  );
}

export default Login;
